export const FormTypes = {
  FORM_TYPE_LARGE: 1,
  FORM_TYPE_SMALL: 2,
  FORM_TYPE_APPLICATION: 3,
};

export const FormTypesList = [
  { id: FormTypes.FORM_TYPE_LARGE, name: 'Groß' },
  { id: FormTypes.FORM_TYPE_SMALL, name: 'Klein' },
  { id: FormTypes.FORM_TYPE_APPLICATION, name: 'Online Bewerbung' },
];
